var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"be-switcher",attrs:{"for":_vm.id}},[_c('input',{attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":_vm.checked},on:{"input":(e) => _vm.$emit('input', e.target.checked)}}),_c('span',{staticClass:"be-switcher__lever"}),_c('span',{staticClass:"be-switcher__text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }